<template>
  <div class="pbr-header">
    <nav class="nav">
      <div class="pbr-title">{{ $t('rootTitle') }}</div>
      <div class="pbr-notice" v-if="$route.name === 'pbrIndex' && noticeList.length > 0">
        <i class="el-alert__icon el-icon-warning"></i>
        <!-- <Icon type="md-volume-up" :size="18"/> -->
        <div class="pbr-notice-content">
          <el-carousel height="25px" direction="vertical" indicator-position="none" :autoplay="true">
            <el-carousel-item v-for="item in noticeList" :key="item.id"
                              style="display:flex;justify-content:space-between">
              <a href="javascript:void(0)" @click="$router.push({name:'pbrInfoDetail', query:{key:item.articleId}})"
                 class="item">{{ item.title }}</a>
              <span class="pbr-notice-time">{{ $moment(item.createDate).format('yyyy-MM-DD') }}</span>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <ul class="pbr-menu-list" @click.stop="()=>{}">
        <li :class="isHomeActive ? 'active' : ''">
          <a href="#/pbr/index">{{$t('header.home')}}</a>
        </li>
        <li :class="isProjectActive ? 'active' : ''">
          <a href="#/pbr/project?tab=project">{{$t('header.project')}}</a>
        </li>
        <li :class="isBiddingActive ? 'active' : ''">
          <a href="#/pbr/project?tab=bidding">{{$t('header.bidding')}}</a>
        </li>
        <li :class="isExhibitionActive ? 'active' : ''">
          <a href="#/pbr/project?tab=exhibition">{{$t('header.exhibition')}}</a>
        </li>
        <li :class="['/pbr/info','/pbr/info/detail','/pbr/business/detail','/pbr/risk/detail'].includes($route.path) ? 'active' : ''">
          <a href="#/pbr/info">{{$t('header.information')}}</a>
        </li>
        <li :class="$route.path.includes('/pbr/analysis') ? 'active' : ''">
          <a href="#/pbr/analysis">{{$t('header.analysis')}}</a>
        </li>
        <li :class="$route.path.includes('/pbr/topic') ? 'active' : ''">
          <a href="#/pbr/topic">{{$t('header.special')}}</a>
        </li>
      </ul>
      <!--<div class="div-xs-hidden" style="position:absolute; right:0;z-index: 99">
        <el-checkbox class="div-xs-hidden" ref="full" label="全屏" border size="mini" v-model="isFull" :true-label="1" :false-value="0" @change="hideContainer"></el-checkbox>
        <el-button @click="$router.push({name: 'project'})" size="mini">项目投融资</el-button>
      </div>-->
    </nav>

    <!--    模拟登录-form-->
    <el-dialog title="切换用户" :visible.sync="dialogFormVisible">
      <el-form :model="form" ref="loginForm">
        <el-form-item label="用户名" :label-width="formLabelWidth" prop="name">
          <el-input v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="密码" :label-width="formLabelWidth" prop="pass">
          <el-input type="password" v-model="form.pass" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('loginForm')">确 定</el-button>
      </div>
    </el-dialog>


  </div>
</template>

<script>
import en from 'view-design/dist/locale/en-US';
import zh from 'view-design/dist/locale/zh-CN';
import { locale, Page } from 'view-design';
import {
  OPPORTUNITY_TAB,
  DEFAULT_OPPORTUNITY_TAB,
  normalizeOpportunityTab
} from './project/opportunityTabs';
export default {
  name: 'pbrHeader',
  props: {
    title: {
      type: String,
      require: true
    },
    noticeList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  computed: {
    opportunityTab () {
      const path = this.$route.path
      if (path.includes('/pbr/exhibition/detail')) {
        return OPPORTUNITY_TAB.EXHIBITION
      }
      if (path.includes('/pbr/project/detail') || path === '/pbr/project') {
        return normalizeOpportunityTab(this.$route.query.tab) || DEFAULT_OPPORTUNITY_TAB
      }
      if (path.includes('/pbr/company')) {
        return OPPORTUNITY_TAB.PROJECT
      }
      return null
    },
    isHomeActive () {
      return this.$route.path.includes('/pbr/index')
    },
    isBiddingActive () {
      return this.opportunityTab === OPPORTUNITY_TAB.BIDDING
    },
    isExhibitionActive () {
      return this.opportunityTab === OPPORTUNITY_TAB.EXHIBITION
    },
    isProjectActive () {
      return this.opportunityTab === OPPORTUNITY_TAB.PROJECT
    }
  },
  data () {
    return {
      dialogFormVisible: false,
      generateAllDropdownSelected: false,
      generatePartDropdownSelected: false,
      enSelected: false,
      cnSelected: false,
      isFull: false,
      form: {
        name: '',
        pass: ''
      },
      switchLangValue:localStorage.getItem('locale'),
      isEn: localStorage.getItem('locale') === 'en',
      switchThemeValue:'white',
      formLabelWidth: '120px'
    }
  },
  methods: {
    hideContainer (full){
      this.$store.commit('hideContainer',full)

      if (full){
        document.querySelector("#app header").style.height = 0
        document.querySelector("#app header").style.overflow = 'hidden'
        document.querySelector('#myapp .left_content').style.display = 'none'
        document.querySelector("#myapp .content").classList.add("col-md-12")
        document.querySelector("#myapp .content").classList.add("col-ms-12")
        document.querySelector(".content").style.minHeight = '100vh'
        document.querySelector(".pbr-box").style.height = '100vh'

        if (document.querySelector(".patch-home")){
          document.querySelector(".patch-home").style.height = '100vh !important'
        }
      }else{
        document.querySelector("#app header").style.height = ''
        document.querySelector("#app header").style.overflow = ''
        document.querySelector('#myapp .left_content').style.display = ''
        document.querySelector("#myapp .content").classList.remove("col-md-12")
        document.querySelector("#myapp .content").classList.remove("col-ms-12")
        document.querySelector(".content").style.minHeight = ''
        document.querySelector(".pbr-box").style.height = 'calc(100vh - 65px)'
        if (document.querySelector(".patch-home")){
          document.querySelector(".patch-home").style.height = ''
        }
      }
      // this.$nextTick(()=>{
      //   document.querySelector("#app header").hidden = true
      //   document.querySelector('#myapp .left_content').style.display = 'none'
      //   document.querySelector("#myapp .content").classList.add("col-md-12")
      //   document.querySelector("#myapp .content").classList.add("col-ms-12")
      //   document.querySelector(".content").style.minHeight = '100vh'
      //   // this.timer = setTimeout(function (){
      //   //   if(document.querySelector(".pbr-router"))
      //   //   {document.querySelector(".pbr-router").style.height = 'calc(100%)'}
      //   //   try{
      //   //     let ev = document.createEvent('Event');
      //   //     ev.initEvent('resize', true, true);
      //   //     window.dispatchEvent(ev);
      //   //   }catch (e) {
      //   //   }
      //   // },500)
      // })
    },
    changeLocale(isEn){
      this.isEn = isEn
      localStorage.setItem('locale', isEn ? 'en' : 'cn')
      setTimeout(() => {
        location.reload()
      }, 1000)
    },
    changeLang (name){
      // let lang = this.$i18n.locale === 'zh' ? 'en' : 'zh'
      localStorage.setItem('locale', name)
      // this.$i18n.locale = localStorage.getItem('locale')
      setTimeout(() => {
        location.reload()
      }, 1000)
    },
    langVisibleChange(){
      this.enSelected = localStorage.getItem('locale') === 'en'
      this.cnSelected = !this.enSelected
    },
    launchLoginForm () {
      this.resetForm('loginForm')
      this.dialogFormVisible = true
    },
    submitForm (formName) {
      this.dialogFormVisible = false
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert('submit!')
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    resetForm (formName) {
      this.$refs[formName] && this.$refs[formName].resetFields()
    }
  },
  mounted () {

  }
}
</script>

<style scoped>
>>> .el-button, >>> .el-checkbox.is-bordered.el-checkbox--mini .el-checkbox__label {
  color:#333;
  font-weight: normal;
  font-size: inherit;
  line-height: 12px;
}
>>> .el-button:focus, .el-button:hover, >>> .el-checkbox.is-bordered.el-checkbox--mini .el-checkbox__label:hover {
  color:#008acd;
  background-color: inherit;
}
.nav {
  position: relative;
}
.nav ul {
  margin: 0;
  padding: 0;
}

@media screen and (max-width: 600px) {
  .nav a:hover {
    color: #d0d0d0;
  }
  .nav {
    position: relative;
    min-height: 20px;
    z-index: 999;
  }

  .nav ul {
    width: 100px;
    padding: 0;
    position: absolute;
    top: 0;
    left: 0;
    border: solid 1px #ebedee;
    background: #fff url(common/img/menu.png) no-repeat 10px 7px;
    border-radius: 5px;
    box-shadow: 0 1px 2px rgba(0,0,0,.15);
  }
  .nav li {
    display: none; /* hide all <li> items */
    margin: 0;
    border:none !important;
    background-color: transparent !important;
  }
  .nav .active {
    display: block; /* show only active <li> item */
  }
  .nav a {
    display: block;
    padding: 0 5px 0 32px;
    text-align: left;
  }
  .nav .active a {
    background: none;
    color: #666;
  }
  /* on nav hover */
  .nav ul:hover {
    background-image: none;
  }
  .nav ul:hover li {
    display: block;
    margin: 0 0 5px;
  }
  .nav ul:hover .active {
    background: url(common/img/check.png) no-repeat 10px 7px;
  }
}

</style>
